<template>
  <a-modal
    title="添加云卡"
    v-model="visible"
    @ok="handleOk"
    :maskClosable="false"
  >
    <p style="color: red;"> * 温馨提示：教材绑定，无法更改，请谨慎选择。</p>
    <a-spin :spinning="spinning">
      <a-form :form="form">
        <a-form-item label="云卡激活码">
          <a-input
            placeholder="请输入云卡激活码"
            v-decorator="['cardNum', {rules: [{ required: true, message: '请输入云卡激活码!' }, { validator: this.handleCardNumCheck }], validateTrigger: ['pressEnter', 'blur']}]"
          />
        </a-form-item>
        <a-form-item label="选择出版社">
          <a-select
            placeholder="请选择出版社"
            v-decorator="['press',{rules: [{ required: true, message: '请选择出版社!' }]}]"
          >
            <a-select-option
              v-for="item in pressData"
              :key="item.index"
              :value="item.value"
            >{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="选择起点类型"
          v-if="visibleType"
        >
          <a-select
            placeholder="请选择起点类型"
            v-decorator="['originType',{rules: [{ required: true, message: '请选择起点类型!' }]}]"
          >
            <a-select-option value="1">一年级起点</a-select-option>
            <a-select-option value="2">三年级起点</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>

import { getCard, putObj } from '@/api/account/mycloudcard'
import { getPressList } from '@/api/sys/dict'
import { mapGetters } from 'vuex'
export default {
  name: 'AddCardModal',
  data () {
    return {
      pressData: [],
      visible: false,
      spinning: false,
      visibleType: false,
      cardForm: {},
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    // this.getDictList()
  },
  methods: {
    handleOpen () {
      this.visible = true
      this.visibleType = false
      this.form.resetFields()
    },
    // 获取出版社
    getDictList (value) {
      const mdl = {}
      mdl.type = 'press_type'
      mdl.period = value
      getPressList(Object.assign(mdl)).then(res => {
        this.pressData = res.result
      })
    },
    handleOk (e) {
      e.preventDefault()
      const _this = this
      _this.form.validateFields((err, values) => {
        if (!err) {
          _this.spinning = true
          this.cardForm.press = values.press
          this.cardForm.originType = values.originType
          putObj(Object.assign(this.cardForm)).then((res) => {
            if (res.result === 1) {
              _this.$message.success('云卡激活成功！')
              this.setUserInfo()
              _this.$router.push({ path: '/dashboard/workplace' })
            } else {
              _this.$message.error('云卡已被激活，请更换激活码！')
            }
          }).catch(() => {
            _this.$message.error('云卡激活失败！')
          }).finally(() => {
            _this.spinning = false
            _this.visible = false
          })
        }
      })
    },
    handleCardNumCheck (rule, value, callback) {
      if (value && value.trim() !== '') {
        const dataForm = {}
        dataForm.cardState = '0'
        dataForm.cardNum = value.trim()
        getCard(dataForm).then(res => {
          console.log('data:' + JSON.stringify(res.result[0]))
          if (res.result.length === 1) {
            this.cardForm = res.result[0]
            if (res.result[0].cardSection === '1') {
              this.visibleType = true
            } else {
              this.visibleType = false
            }
            this.getDictList(res.result[0].cardSection)
          } else {
            this.$message.error('激活码错误，或云卡已激活,请检查激活码！')
          }
        }).catch(() => {
          this.visibleType = false
          this.$message.error('激活码错误，或云卡已激活,请检查激活码！')
        })
      } else {
        this.visibleType = false
        callback(new Error('激活码不为空字符！'))
      }
      callback()
    },
    setUserInfo () {
      // 当前云卡学段
      if (this.cardForm.cardSection === '1') {
        this.userInfo.originType = this.cardForm.originType
        // 起点类型
        if (this.cardForm.originType === '1') {
          this.userInfo.classYear = '1'
        }
        if (this.cardForm.originType === '2') {
          this.userInfo.classYear = '3'
        }
      }
      if (this.cardForm.cardSection === '2') {
        this.userInfo.classYear = '7'
      }
      if (this.cardForm.cardSection === '3') {
        this.userInfo.classYear = '10'
      }
      this.userInfo.stuPress = this.cardForm.press
      this.userInfo.vipType = '1'
      this.userInfo.stuSection = this.cardForm.cardSection
    }
  }
}
</script>

<style scoped>
</style>
